import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-gridnine",
  "use": "icon-th-gridnine-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-gridnine\">\n<path d=\"M27 6H5C4.46957 6 3.96086 6.21071 3.58579 6.58579C3.21071 6.96086 3 7.46957 3 8V24C3 24.5304 3.21071 25.0391 3.58579 25.4142C3.96086 25.7893 4.46957 26 5 26H27C27.5304 26 28.0391 25.7893 28.4142 25.4142C28.7893 25.0391 29 24.5304 29 24V8C29 7.46957 28.7893 6.96086 28.4142 6.58579C28.0391 6.21071 27.5304 6 27 6ZM13 18V14H19V18H13ZM19 20V24H13V20H19ZM5 14H11V18H5V14ZM13 12V8H19V12H13ZM21 14H27V18H21V14ZM27 12H21V8H27V12ZM11 8V12H5V8H11ZM5 20H11V24H5V20ZM27 24H21V20H27V24Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-gridnine.svg
// module id = ArMF
// module chunks = 84